import {clientT} from "../../../../tools/i18n";

export default function StatusTag({ status }) {
  return (
    <div className={`StatusTag ${status}`}>
      {clientT(`myTicketsV2.PaymentCard.status.${status}`)}
    </div>
  );
};
